import { createAsyncThunk } from '@reduxjs/toolkit';
import { dataSourcesService, physicianService } from '../../services';

const getImportance = createAsyncThunk(
    'physician/getImportance',
    async (payload, ThunkAPI) => {
        try {
            const response = await physicianService.getImportance(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getIntensity = createAsyncThunk(
    'physician/getIntensity',
    async (payload, ThunkAPI) => {
        try {
            const response = await physicianService.getIntensity(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const postImportance = createAsyncThunk(
    'physician/postImportance',
    async (payload, ThunkAPI) => {
        try {
            const response = await physicianService.postImportance(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const postIntensity = createAsyncThunk(
    'physician/postIntensity',
    async (payload, ThunkAPI) => {
        try {
            const response = await physicianService.postIntensity(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPhysiciansList = createAsyncThunk(
    'physician/getPhysiciansList',
    async (payload, ThunkAPI) => {
        const {
            companyId, position, page_size,searchValue, type 
        } = payload; 
        try {
            const response = await physicianService.getPhysiciansList(companyId, position,page_size,searchValue, type);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getHcpProfileData = createAsyncThunk(
    'physician/getHcpProfileData',
    async (payload, ThunkAPI) => {
        try {
            const response = await physicianService.getHcpProfileData(payload.companyId, payload.npiId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);


export {
    getImportance,
    getIntensity,
    postImportance,
    postIntensity,
    getPhysiciansList,
    getHcpProfileData
};
